import { render, staticRenderFns } from "./UsageVoice12MonthsLineChart.vue?vue&type=template&id=6c1ef3ae&scoped=true&"
import script from "./UsageVoice12MonthsLineChart.vue?vue&type=script&lang=js&"
export * from "./UsageVoice12MonthsLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1ef3ae",
  null
  
)

export default component.exports